import { isDefined } from "@clipboard-health/util-ts";
import { areCommaSeparatedSetsEqual } from "@src/appV2/redesign/PlacementCandidate/constants";

interface GetLicenseFilterLabelParams {
  rawLicenseValues: string | undefined;
  availableLicenseValues: string[];
  shouldShowLicenses: boolean;
}

export function getLicenseFilterLabel(params: GetLicenseFilterLabelParams): string | undefined {
  const { rawLicenseValues, availableLicenseValues, shouldShowLicenses } = params;

  if (!shouldShowLicenses || !isDefined(rawLicenseValues) || rawLicenseValues === "") {
    return undefined;
  }

  const defaultLicenseValues = availableLicenseValues.join(",");

  if (areCommaSeparatedSetsEqual(rawLicenseValues, defaultLicenseValues)) {
    return undefined;
  }

  const licenseLabels = rawLicenseValues
    .split(",")
    .filter((licenseLabel) => licenseLabel.length > 0);

  if (licenseLabels.length === 0) {
    return undefined;
  }

  return licenseLabels.join(", ");
}
